<template>
    <div class="delivery-guarantee">
      <div :style="{ marginLeft: '24px' }">
      <titleColor :title="asd" />
      </div>
        <view class="list">
          <view class="listdetail" v-for="item in guarantee" :key="item.id">
            <view class="listleft" :style="{ background: item.background}">
              <text>{{ item.text }}</text>
            </view>
            <view class="listright">
              <text>{{ item.title }}</text>
              <text>{{ item.subtitle }}</text>
            </view>
          </view>
        </view>
    </div>
</template>

<script>
import titleColor from '@/components/titleColor.vue'
export default {
  components: {
    titleColor,
  },
  data() {
    return {
      backgroundColor: '#2F82FF',
      guarantee: [
        {
          id: 1,
          title: '一站式发货',
          text: '省事',
          subtitle: '在线下单，轻松一键搞定',
          background: `url(${require('@/assets/home/hint-a.png')})`,
        },
        {
          id: 2,
          title: '门到门送货',
          text: '省心',
          subtitle: '全程一票制，服务门到门',
          background: `url(${require('@/assets/home/hint-b.png')})`,
        },
        {
          id: 3,
          title: '下单就省钱',
          text: '省钱',
          subtitle: '先比价后下单在线支付优惠多',
          background: `url(${require('@/assets/home/hint-c.png')})`,
        },
        {
          id: 4,
          title: '先行赔付',
          text: '放心',
          subtitle: '你发货，我投保，先行赔付',
          background: `url(${require('@/assets/home/hint-d.png')})`,
        }
      ],
      asd: "在线发货保障",
    }
  }
}
</script>

<style scoped lang="scss">
.delivery-guarantee {
  width: 450px;
  height: 372px;
  background-color: white;
  margin-left: 24px;
  margin-top: 24px;
  padding-top: 24px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  .list{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px;
    margin: 24px;
    .listdetail{
      display: flex;
      width: 192px;
      height: 122px;
      background: #F1F6FF;
      align-items: center;
    }
    .listleft{
      width: 48px;
      height: 48px;
      box-sizing: border-box;
      margin-left: 16px;
      display: flex;
      text{
        height: 48px;
        width: 48px;
        display: flex;
        justify-content: center; /* 水平居中文本 */
        align-items: center; /* 垂直居中文本 */
        // 字体
        font-family: Alimama ShuHeiTi;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: normal;
        color: #FFFFFF;
      }
    }
    .listright{
      width: 100px;
      display: flex;
      flex-direction: column;
      margin-left: 8px;
      text{
        text-align: left;
        &:nth-of-type(1){
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 500;
          line-height: 30px;
          letter-spacing: normal;
          color: #001E5B;
        }
        &:nth-of-type(2){
          font-family: PingFang SC;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: normal;
          color: rgba(0, 30, 91, 0.6);
        }
      }
    }
  }
}
</style>
